import { action, observable, makeObservable } from 'mobx';
import { IUser } from 'stores/user/UserStore';

export interface IComment {
    id: string;
    starred: boolean;
    relatedId: string;
    value: string;
    userId: string;
    createdOn: Date;
    author?: IUser;
    autoGenerated: boolean;
}

export default class CommentStore {
    comment: IComment = {
        id: '',
        userId: '',
        relatedId: '',
        starred: false,
        value: '',
        createdOn: new Date()
    };

    constructor(comment: IComment) {
        makeObservable(this, {
            comment: observable,
            update: action
        });

        this.update(comment);
    }

    update(comment: IComment): void {
        this.comment = {
            ...this.comment,
            ...comment
        };
    }
}
